import { humanise } from "@/lib/format";

/**
 * What a profile field is called on screen.
 *
 * The API sends change payloads keyed by column name, and a reviewer should
 * read "Account holder", not "account_holder_name". Anything not listed falls
 * back to the column name with its underscores taken out.
 */
export const FIELD_LABELS: Record<string, string> = {
  full_name_en: "Name in English",
  full_name_ar: "Name in Arabic",
  gender: "Gender",
  date_of_birth: "Date of birth",
  nationality: "Nationality",
  marital_status: "Marital status",
  profile_picture_file_id: "Profile picture",
  personal_mobile: "Mobile number",
  whatsapp_number: "WhatsApp number",
  personal_email: "Personal email",
  emirate_of_residence: "Emirate",
  full_address: "Home address",
  emergency_contact_name: "Emergency contact name",
  emergency_contact_relationship: "Emergency contact relationship",
  emergency_contact_mobile: "Emergency contact mobile",
  emirates_id_number: "Emirates ID number",
  emirates_id_issue: "Emirates ID issue date",
  emirates_id_expiry: "Emirates ID expiry date",
  emirates_id_front_file_id: "Emirates ID copy",
  emirates_id_back_file_id: "Emirates ID, back (older upload)",
  passport_number: "Passport number",
  passport_issue: "Passport issue date",
  passport_expiry: "Passport expiry date",
  passport_file_id: "Passport copy",
  visa_type: "Visa type",
  visa_number: "Visa number",
  visa_issue: "Visa issue date",
  visa_expiry: "Visa expiry date",
  visa_file_id: "Visa copy",
  highest_education: "Highest qualification",
  cv_file_id: "CV",
  degree_file_id: "Degree certificate",
  experience_letter_file_id: "Experience letter",
  other_file_id: "Other document",
  signature_file_id: "Signature",
  bank_name: "Bank name",
  iban: "IBAN",
  account_holder_name: "Account holder",
  iban_letter_file_id: "IBAN letter",
  nominee_name: "Nominee name",
  nominee_relationship: "Nominee relationship",
  nominee_nationality: "Nominee nationality",
  nominee_mobile: "Nominee mobile",
  nominee_address: "Nominee address",
  employee_id: "Employee number",
  position_title: "Position",
  departments: "Departments",
  date_of_joining: "Date of joining",
  labour_card_number: "Labour card number",
  labour_card_issue: "Labour card issue date",
  labour_card_expiry: "Labour card expiry date",
  labour_card_file_id: "Labour card copy",
  health_insurance_provider: "Health insurance provider",
  health_insurance_number: "Health insurance policy number",
  health_insurance_issue: "Health insurance start date",
  health_insurance_expiry: "Health insurance expiry date",
  health_insurance_file_id: "Health insurance card",
  contract_start: "Contract start date",
  contract_expiry: "Contract expiry date",
  contract_file_id: "Signed contract",
  basic_salary: "Basic salary",
  allowances: "Allowances",
  hours_per_day: "Working hours per day",
  weekly_off_days: "Days off",
  days_off_rotate: "Rotational days off",
  declaration_accepted_at: "Declaration",
};

/** The parts of a record a change request can be about, in plain words. */
export const SECTION_LABELS: Record<string, string> = {
  contact: "Contact details",
  emergency: "Emergency contact",
  identity: "Identity",
  emirates_id: "Emirates ID",
  passport: "Passport",
  visa: "Visa",
  labour_insurance: "Labour card and insurance",
  education: "Education",
  hours: "Working hours and days off",
  signature: "Signature",
  bank: "Bank account",
  nomination: "Nomination",
};

export function fieldLabel(field: string): string {
  return FIELD_LABELS[field] ?? humanise(field);
}

export function sectionLabel(section: string): string {
  return SECTION_LABELS[section] ?? humanise(section);
}
